module.exports = __webpack_public_path__ + "img/fitness friendHeader.33542868.png";